import { Type, Transform } from 'class-transformer';
import { IsInt, ValidateNested } from 'class-validator';
import type { EFrontElement } from '../../../core/EFrontElement';
import type { DrawCabinetFrontElementGroup } from './DrawCabinetFrontElementGroup';
import type { IDrawCabinetInsideElement } from '../Inside/IDrawCabinetInsideElement';
import { DrawCabinetInsideElement } from '../Inside/DrawCabinetInsideElement';
import { DrawInsideLiftingColumn } from '../Inside/DrawInsideLiftingColumn';
import { DrawInsideBottleShelf } from '../Inside/DrawInsideBottleShelf';
import { DrawInsideDoorRack } from '../Inside/DrawInsideDoorRack';
import { DrawInsideHookBar } from '../Inside/DrawInsideHookBar';
import { DrawInsidePlateHolder } from '../Inside/DrawInsidePlateHolder';
import { DrawInsideShelf } from '../Inside/DrawInsideShelf';
import { DrawInsideShelfSystem } from '../Inside/DrawInsideShelfSystem';
import { DrawInsideTablet } from '../Inside/DrawInsideTablet';
import { DrawCabinetInsideGroupElement } from '../Inside/DrawCabinetInsideGroupElement';
import { DrawInsideTrashCan } from '../Inside/DrawInsideTrashCan';
import { DrawInsideTray } from '../Inside/DrawInsideTray';
import { Length } from '../../../core/Length/Length';
import { LengthDefault } from '../../../core/Length/LengthDefault';
import { LengthParser } from '../../../core/Length/LengthParser';

export class DrawCabinetFrontElement {
    TypeName!: string;

    FrontElement!: EFrontElement;

    @IsInt()
    Order!: number;

    @ValidateNested()
    @Transform(params => LengthParser.parse(params.value))
    Height: Length = LengthDefault.Auto;

    @ValidateNested()
    @Transform(params => LengthParser.parse(params.value))
    Width!: Length;

    @ValidateNested()
    @Type(() => DrawCabinetInsideElement, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: 'TypeName',
            subTypes: [
                { value: DrawCabinetInsideElement, name: 'DrawCabinetInsideElement' },
                { value: DrawCabinetInsideGroupElement, name: 'DrawCabinetInsideGroupElement' },
                { value: DrawInsideBottleShelf, name: 'DrawInsideBottleShelf' },
                { value: DrawInsideDoorRack, name: 'DrawInsideDoorRack' },
                { value: DrawInsideHookBar, name: 'DrawInsideHookBar' },
                { value: DrawInsideLiftingColumn, name: 'DrawInsideLiftingColumn' },
                { value: DrawInsidePlateHolder, name: 'DrawInsidePlateHolder' },
                { value: DrawInsideShelf, name: 'DrawInsideShelf' },
                { value: DrawInsideShelfSystem, name: 'DrawInsideShelfSystem' },
                { value: DrawInsideTablet, name: 'DrawInsideTablet' },
                { value: DrawInsideTrashCan, name: 'DrawInsideTrashCan' },
                { value: DrawInsideTray, name: 'DrawInsideTray' },
                // Add other subclasses here
            ],
        },
    })
    Inside?: IDrawCabinetInsideElement;

    toFlatHierarchy(): DrawCabinetFrontElement[] {
        return [this];
    }

    groupToFlatHierarchy(): DrawCabinetFrontElementGroup[] {
        return [];
    }

    findParentOf(searchedChild: DrawCabinetFrontElement): DrawCabinetFrontElementGroup | null {
        return null;
    }
}
